// File Metadata:
// Filename: AuthLoader.jsx
// Version: 1.12
// Created: 2025-03-20 22:45:57
// Last Modified: 2025-06-20
// Authors: Dieuwer Descheemaecker, GitHub Copilot
// Description: Component to handle authentication loading using RTK Query and token refresh scheduling

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetMeQuery } from '../store/authApi';
import { setCredentials, setupTokenRefresh } from '@/store/slices/userSlice';
import LoadingScreen from '@/components/common/LoadingScreen';

const AuthLoader = ({ children }) => {
  const dispatch = useDispatch();
  const { data: user, token } = useSelector((state) => state.user);
  
  // Use RTK Query to get current user if we have a token
  const {
    data: userData,
    isLoading,
    error,
    isSuccess
  } = useGetMeQuery(undefined, {
    skip: !token || !!user, // Skip if no token or user already loaded
  });

  // Set user data when query succeeds
  useEffect(() => {
    if (isSuccess && userData && !user) {
      dispatch(setCredentials({ user: userData, accessToken: token }));
    }
  }, [isSuccess, userData, user, token, dispatch]);

  // Setup token refresh when user is loaded successfully
  useEffect(() => {
    if (user && token) {
      setupTokenRefresh(dispatch);
    }
  }, [user, token, dispatch]);

  if (isLoading) return <LoadingScreen message="Authenticating…" />;
  return children;
};

export default AuthLoader;